// extracted by mini-css-extract-plugin
export default {"container":"showNumberSection_container__VqmY4","items_wrapper":"showNumberSection_items_wrapper__ORXW7","item_container":"showNumberSection_item_container__Jya1v"};